import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { isString } from "__barrel_optimize__?names=isString!=!lodash-es";
import classNames from "classnames";
import { NewBaseButton } from "../NewBaseButton";
import { NewBaseIcon } from "../NewBaseIcon";
import styles from "./index.module.scss";
export const BaseIconButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    icon,
    innerClassName,
    position = "left",
    iconSize,
    loading,
    className,
    iconColor,
    size = "medium",
    iconClassName,
    ...restProps
  } = props;
  const defaultIconSize = ["nano", "mini", "small"].includes(size) ? 16 : 20;
  const renderChildren = isString(children) ? /*#__PURE__*/_jsx("span", {
    children: children
  }) : children;
  return /*#__PURE__*/_jsxs(NewBaseButton, {
    ref: ref,
    size: size,
    className: classNames([styles.outer], [className]),
    innerClassName: classNames(innerClassName, {
      [styles["size_".concat(size)]]: !children
    }),
    loading: loading,
    ...restProps,
    children: [position === "left" && !loading && /*#__PURE__*/_jsx(NewBaseIcon, {
      className: iconClassName,
      icon: icon,
      size: iconSize || defaultIconSize,
      color: iconColor
    }), renderChildren, position === "right" && /*#__PURE__*/_jsx(NewBaseIcon, {
      className: iconClassName,
      icon: icon,
      size: iconSize || defaultIconSize
    })]
  });
});